import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_WALLET_DELETE_QUERY_KEY = "bot-wallet-delete";

type BotWalletDeleteParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  walletAddress: string;
};

const postBotWalletDelete = async (api: Api, params: BotWalletDeleteParams) =>
  api.post("wallet/delete", { json: params }).json();

const useBotWalletDeleteMutation = () =>
  useMutation({
    mutationFn: async (params: BotWalletDeleteParams) =>
      postBotWalletDelete(api, params),
    mutationKey: [BOT_WALLET_DELETE_QUERY_KEY],
  });

export {
  useBotWalletDeleteMutation,
  postBotWalletDelete,
  BOT_WALLET_DELETE_QUERY_KEY,
};
